export function extractCode(str: string): string {
  return str?.split('-').shift()?.trim() ?? '';
}

export function getAdditionalDetails(
  desc: string | undefined,
  name: string | undefined,
  location: string | undefined
): string {
  let additionalDetails: string | undefined;
  if (name || location) {
    additionalDetails = `${location ? location : ''} ${name}`.trim();
  } else {
    additionalDetails = desc;
  }

  return additionalDetails || 'Add Additional Details';
}
